import { type WatchQueryFetchPolicy, useQuery } from "@apollo/client";
import { type GetCameraKitOrganizationsQuery } from "../api/query/getOrganizations.gql-generated";
import { getOrganizations } from "../api/query";

export function useOrganizations(fetchPolicy: WatchQueryFetchPolicy = "cache-first") {
    const { data, loading } = useQuery<GetCameraKitOrganizationsQuery>(getOrganizations, {
        fetchPolicy,
        errorPolicy: "all",
    });

    return {
        loading: loading,
        organizations: data?.getOrganizations?.organizations || [],
    };
}
